/**
 * Scrolls the elements viewport to the bottom.
 * Relevant for a chat-message list.
 *
 * https://stackoverflow.com/a/18614545/4338833
 * */
// eslint-disable-next-line import/prefer-default-export
export const scrollTopBottom = (element) => {
  if (!element) {
    return;
  }
  // eslint-disable-next-line no-param-reassign
  element.scrollTop = element.scrollHeight;
};
